module.exports = __webpack_public_path__ + "img/image_ot-peru-supe_tanks_1920px.40f62ead.jpg";